import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Button, Link } from '../../../../..';

import styles from './GridInfoBlock.module.scss';

const renderCta = (cta, className) => {
  if (!cta) return null;

  if (cta.type === 'button') {
    return (
      <Button
        color="tertiary"
        size="large"
        href={cta.url}
        className={className}
      >
        {cta.text}
      </Button>
    );
  }

  return (
    <Link href={cta.url} className={className}>
      {cta.text}
    </Link>
  );
};

const GridInfoBlock = ({
  title,
  label = null,
  description = null,
  cta = null,
  renderImage = null,
  hideImageOnMobile = false,
  hideTitleOnMobile = false,
  titleTag = 'h3',
  className = ''
}) => {
  const hasImage = !!renderImage;
  const hasDescription = !!description;
  const showDescriptionOnMobileOnly = hasImage && hasDescription;

  const TitleTag = titleTag;

  return (
    <div
      className={classNames(styles['grid-info-block'], className, {
        [styles['grid-info-block--with-image']]: hasImage
      })}
    >
      <div className={styles['grid-info-block__content']}>
        <div className={styles['grid-info-block__title-container']}>
          {label && (
            <div className={styles['grid-info-block__title-label']}>
              {label}
            </div>
          )}
          <TitleTag
            className={classNames(styles['grid-info-block__title'], {
              [styles['grid-info-block__title--hide-on-mobile']]:
                hideTitleOnMobile
            })}
          >
            {title}
          </TitleTag>
        </div>
        {description && (
          <p
            className={classNames(styles['grid-info-block__text'], {
              [styles['grid-info-block__text--mobile-only']]:
                showDescriptionOnMobileOnly
            })}
          >
            {description}
          </p>
        )}
        {cta && renderCta(cta, styles['grid-info-block__cta'])}
      </div>
      {hasImage &&
        renderImage(
          classNames(styles['grid-info-block__image'], {
            [styles['grid-info-block__image--hide-on-mobile']]:
              hideImageOnMobile
          })
        )}
    </div>
  );
};

GridInfoBlock.propTypes = {
  title: PropTypes.string.isRequired,
  label: PropTypes.string,
  description: PropTypes.string,
  cta: PropTypes.shape({
    url: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['button', 'link'])
  }),
  renderImage: PropTypes.func,
  hideImageOnMobile: PropTypes.bool,
  hideTitleOnMobile: PropTypes.bool,
  titleTag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  className: PropTypes.string
};

export default GridInfoBlock;
